module.exports = __webpack_public_path__ + "img/sink-fixed.cc82851c.png";